import React, { Component } from 'react';

import moment from 'moment';

import ValidationManager from '../../../managers/ValidationManager';

import TypeSlide from '../Slides/TypeSlide';
import ScopeSlide from '../Slides/ScopeSlide';
import NameSlide from '../Slides/NameSlide';
import DateSlide from '../Slides/DateSlide';
import MetricQuantitySlide from '../Slides/MetricQuantitySlide';
import RankedMetricSlide from '../Slides/RankedMetricSlide';
import RaffleMetricSlide from '../Slides/RaffleMetricSlide';
import HasQualifierSlide from '../Slides/HasQualifierSlide';
import QualifierSlide from '../Slides/QualifierSlide';
import SummarySlide from '../Slides/SummarySlide';

export default class NewContestView extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            slideNumber: 0
        }

        // Methods
        this.editForm = this.editForm.bind(this);
        this.editFormByLookup = this.editFormByLookup.bind(this);

        this.generateSlides = this.generateSlides.bind(this);

        this.setSlide = this.setSlide.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.backSlide = this.backSlide.bind(this);
        this.cancel = this.cancel.bind(this);
        this.finish = this.finish.bind(this);
    }

    editForm(field, value) {
        let form = this.props.newContestForm;

        if (form[field] != value) {
            form[field] = value;
        }

        this.props.editNewContest(form);
    }

    editFormByLookup(field, lookupMap, value) {
        let form = this.props.newContestForm;

        let tmpValue = lookupMap[value];

        if (form[field] != tmpValue) {
            form[field] = tmpValue;
        }

        this.props.editNewContest(form);
    }


    generateSlides() {

        let form = this.props.newContestForm;

        let rankedTrack = [0, 1, 2, 3, 5, 8];
        let rankedValidators = [
            // type
            ValidationManager.blank,
            // scope
            ValidationManager.contestScopeIsValid.bind(null, form.scope, form.locationId, form.groupId),
            // identity
            () => { return !ValidationManager.isStringNullOrEmpty(form.name) && !ValidationManager.isStringNullOrEmpty(form.description) },
            // date
            () => { return ValidationManager.isDateTimeValid(form.fromDateIndex) && ValidationManager.isDateTimeValid(form.toDateIndex) },
            // metric
            ValidationManager.contestRankedMetricIsValid.bind(null, form.metric, form.scope === "group"),
            // qualifier count
            ValidationManager.blank
        ]
        if (form.hasQualifier) {
            rankedTrack.push(9);
            // qualifier
            rankedValidators.push(ValidationManager.contestQualifierIsValid.bind(null, form.qualifier, form.scope === "group"))
        }
        rankedTrack.push(10);
        rankedValidators.push(ValidationManager.blank)

        let raffleTrack = [0, 1, 2, 3, 4, 5];
        let raffleValidators = [
            // type
            ValidationManager.blank,
            // scope
            ValidationManager.contestScopeIsValid.bind(null, form.scope, form.locationId, form.groupId),
            // identity
            () => { return !ValidationManager.isStringNullOrEmpty(form.name) && !ValidationManager.isStringNullOrEmpty(form.description) },
            // date
            () => { return ValidationManager.isDateTimeValid(form.fromDateIndex) && ValidationManager.isDateTimeValid(form.toDateIndex) },
            // metric count
            ValidationManager.blank,
            // metric1
            ValidationManager.contestRaffleMetricIsValid.bind(null, form.metric, form.scope === "group")
        ]
        if (form.metricCount > 1) {
            // metric2
            raffleTrack.push(6);
            raffleValidators.push(ValidationManager.contestRaffleMetricIsValid.bind(null, form.metric2, form.scope === "group"))
            if (form.metricCount > 2) {
                // metric3
                raffleTrack.push(7);
                raffleValidators.push(ValidationManager.contestRaffleMetricIsValid.bind(null, form.metric3, form.scope === "group"))
            }
        }
        // qualifier count
        raffleTrack.push(8);
        raffleValidators.push(ValidationManager.blank)
        if (form.hasQualifier) {
            // qualifier
            raffleTrack.push(9);
            raffleValidators.push(ValidationManager.contestQualifierIsValid.bind(null, form.qualifier, form.scope === "group"))
        }
        raffleTrack.push(10);
        raffleValidators.push(ValidationManager.blank)

        let slidesJsx = [];
        let slideTrack = form.type === 'ranked' ? rankedTrack : raffleTrack;
        let validators = form.type === 'ranked' ? rankedValidators : raffleValidators;

        let navMap = {
            type: 0,
            scope: 1,
            identity: 2,
            time: 3,
            metrics: 4,
            qualifier: form.type === 'ranked' ? (form.hasQualifier ? 6 : 5) : 5 + form.metricCount + (form.hasQualifier ? 1 : 0)
        }

        // Type
        slidesJsx.push((
            <TypeSlide
                position={0}
                slideNumber={slideTrack[this.state.slideNumber]}
                choices={[{ value: "raffle", icon: "local_activity", displayText: "Ticket Raffle" }, { value: "ranked", icon: "receipt", displayText: "Ranked Competition" }]}
                value={form.type}
                onSelect={this.editForm.bind(null, "type")}
                question={"This contest is a..."}
            />
        ));

        // Scope
        let scopeChoices = [];
        if (Object.keys(this.props.locationMap).length > 0) {
            scopeChoices.push({ value: "ca", hasValue: true, icon: "location_city", displayText: "Account", menuItems: [] });
            if (this.props.participantType === "emp") {
                scopeChoices.push({ value: "location", hasValue: form.locationId != null, icon: "store_mall_directory", displayText: "Location", menuItems: _.sortBy(Object.keys(this.props.locationMap), (obj) => { return obj }) });
            }
        }
        if (Object.keys(this.props.groupMap).length > 0) {
            scopeChoices.push({ value: "group", hasValue: form.groupId != null, icon: "group", displayText: "Group", menuItems: _.sortBy(Object.keys(this.props.groupMap), (obj) => { return obj }) });
        }

        slidesJsx.push((
            <ScopeSlide
                position={1}
                slideNumber={slideTrack[this.state.slideNumber]}
                choices={scopeChoices}
                value={form.scope}
                menuSelectValue={form.scope === 'location' ? this.props.locationMapReverse[form["locationId"]] :
                    form.scope === 'group' ? this.props.groupMapReverse[form["groupId"]] : null}
                onSelect={this.editForm.bind(null, "scope")}
                onMenuSelect={this.editFormByLookup.bind(
                    null, form.scope === 'location' ? "locationId" :
                    form.scope === 'group' ? "groupId" : 'clientAccountId', form.scope === 'location' ? this.props.locationMap :
                    form.scope === 'group' ? this.props.groupMap : {})}
                question={"This contest is targeting a(n)..."}
                question2={"This contest is for the " + form.scope + "..."}
            />
        ));

        // Name/Description
        slidesJsx.push((
            <NameSlide
                position={2}
                slideNumber={slideTrack[this.state.slideNumber]}
                name={form.name}
                description={form.description}
                changeName={this.editForm.bind(null, "name")}
                changeDescription={this.editForm.bind(null, "description")}
            />
        ));

        // Time Frame
        slidesJsx.push((
            <DateSlide
                isActive={this.props.isActive}
                position={3}
                slideNumber={slideTrack[this.state.slideNumber]}
                canChangeTimeFrame={form.type === 'ranked'}
                timeFrame={form.type === 'ranked' ? form.timeFrame : 'day'}
                fromDate={form.fromDateIndex}
                toDate={form.toDateIndex}
                autoPickToDate={form.type === 'ranked'}
                calendarDates={this.props.calendarDates}
                changeTimeFrame={this.editForm.bind(null, "timeFrame")}
                changeFromDate={this.editForm.bind(null, "fromDateIndex")}
                changeToDate={this.editForm.bind(null, "toDateIndex")}
            />
        ));

        // Metric Quantity
        if (form.type === "raffle") {
            slidesJsx.push((
                <MetricQuantitySlide
                    position={4}
                    slideNumber={slideTrack[this.state.slideNumber]}
                    quantity={form.metricCount}
                    onSelect={this.editForm.bind(null, "metricCount")}
                />
            ));
        }

        let kpiMap = this.props.kpiMap;
        let kpiMapReverse = this.props.kpiMapReverse;
        let kpiField = "reportKpiId";
        let scopeMapReverse = this.props.locationMapReverse;
        let scopeField = "locationId";
        if (form.scope === "group") {
            kpiMap = this.props.masterKpiMap;
            kpiMapReverse = this.props.masterKpiMapReverse;
            kpiField = "masterKpiId";
            scopeMapReverse = this.props.groupMapReverse;
            scopeField = "groupId";
        }

        // Ranked Metric
        if (form.type === "ranked") {
            slidesJsx.push((
                <RankedMetricSlide
                    position={5}
                    slideNumber={slideTrack[this.state.slideNumber]}
                    kpiField={kpiField}
                    metric={form.metric}
                    editMetric={this.editForm.bind(null, "metric")}
                    kpiMap={kpiMap}
                    kpiMapReverse={kpiMapReverse}
                />
            ));
        }

        //// Raffle Metrics
        if (form.type === "raffle") {

            // Raffle Metric1
            slidesJsx.push((
                <RaffleMetricSlide
                    position={5}
                    slideNumber={slideTrack[this.state.slideNumber]}
                    kpiField={kpiField}
                    metric={form.metric}
                    editMetric={this.editForm.bind(null, "metric")}
                    kpiMap={kpiMap}
                    kpiMapReverse={kpiMapReverse}
                />
            ));

            if (form.metricCount > 1) {
                // Raffle Metric2
                slidesJsx.push((
                    <RaffleMetricSlide
                        position={6}
                        slideNumber={slideTrack[this.state.slideNumber]}
                        kpiField={kpiField}
                        metric={form.metric2}
                        editMetric={this.editForm.bind(null, "metric2")}
                        kpiMap={kpiMap}
                        kpiMapReverse={kpiMapReverse}
                    />
                ));

                if (form.metricCount > 2) {
                    // Raffle Metric3
                    slidesJsx.push((
                        <RaffleMetricSlide
                            position={7}
                            slideNumber={slideTrack[this.state.slideNumber]}
                            kpiField={kpiField}
                            metric={form.metric3}
                            editMetric={this.editForm.bind(null, "metric3")}
                            kpiMap={kpiMap}
                            kpiMapReverse={kpiMapReverse}
                        />
                    ));
                }
            }
        }

        // Has Qualifier
        slidesJsx.push((
            <HasQualifierSlide
                position={8}
                slideNumber={slideTrack[this.state.slideNumber]}
                onSelect={this.editForm.bind(null, "hasQualifier")}
                value={form.hasQualifier}
            />
        ));

        // Qualifier
        if (form.hasQualifier) {
            slidesJsx.push((
                <QualifierSlide
                    position={9}
                    slideNumber={slideTrack[this.state.slideNumber]}
                    kpiField={kpiField}
                    metric={form.qualifier}
                    editMetric={this.editForm.bind(null, "qualifier")}
                    kpiMap={kpiMap}
                    kpiMapReverse={kpiMapReverse}
                />
            ));
        }

        slidesJsx.push((
            <SummarySlide
                position={10}
                slideNumber={slideTrack[this.state.slideNumber]}
                form={form}
                kpiField={kpiField}
                kpiMapReverse={kpiMapReverse}
                scopeField={scopeField}
                scopeMapReverse={scopeMapReverse}
                hasType={true}
                navMap={navMap}
                navigate={this.setSlide}
            />
        ));

        return { slidesJsx: slidesJsx, validators: validators };
    }

    setSlide(num) {
        this.setState({ slideNumber: num });
    }

    nextSlide() {
        this.setState({ slideNumber: this.state.slideNumber + 1 }, () => {
            // $(".gc-new-slide-container").scrollTop(0)
            $(".gc-new-slide-container").animate({ scrollTop: "0px" }, 150)
        });
    }

    backSlide() {
        this.setState({ slideNumber: this.state.slideNumber - 1 }, () => {
            // $(".gc-new-slide-container").scrollTop(0)
            $(".gc-new-slide-container").animate({ scrollTop: "0px" }, 150)
        });
    }

    cancel() {
        zconfirm("Are you sure you want to cancel?", () => {
            let self = this;
            self.setState({
                slideNumber: 0
            }, () => {
                self.props.cancelNewContest();
            });
        });
    }

    finish() {
        let self = this;

        zconfirm("Are you sure you want to create this contest?", () => {
            self.props.finishNewContest(() => {
                setTimeout(() => {
                    self.setState({ slideNumber: 0 });
                }, 500);
            });

        });
    }

    render() {

        let slidesJsxResult = this.generateSlides();
        let slidesJsx = slidesJsxResult.slidesJsx;
        let validator = slidesJsxResult.validators;

        let slideNumber = this.state.slideNumber < 0 ? 0 : this.state.slideNumber >= validator.length ? validator.length - 1 : this.state.slideNumber;
        let formValidSlide = validator[slideNumber]();
        let formValidFinal = true;

        // Left Button
        let backStyle = {}
        let cancelStyle = { top: '-4.2rem', pointerEvents: 'none', opacity: '0' }
        if (this.state.slideNumber === 0) {
            backStyle = { top: '4.2rem', pointerEvents: 'none', opacity: '0' }
            cancelStyle = {}
        }

        // Right Button
        let nextStyle = {}
        let finishStyle = { top: '-4.2rem', pointerEvents: 'none', opacity: '0' }
        if (this.state.slideNumber === slidesJsx.length - 1) {
            nextStyle = { top: '4.2rem', pointerEvents: 'none', opacity: '0' }
            finishStyle = {}
        }
        if (this.state.slideNumber < slidesJsx.length - 1 && !formValidSlide) {
            nextStyle.opacity = '0.5';
        }
        if (this.state.slideNumber === slidesJsx.length - 1 && !formValidFinal) {
            finishStyle.opacity = '0.5';
        }

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="gc-new-slide-container">
                    {slidesJsx}
                </div>
                <div className="gc-next-bar">
                    <div className="gc-back-button" style={backStyle} onClick={this.backSlide}>BACK</div>
                    <div className="gc-back-button" style={cancelStyle} onClick={this.cancel}>CANCEL</div>
                    <div className="gc-next-button" style={nextStyle} onClick={formValidSlide ? this.nextSlide : null}>NEXT</div>
                    <div className="gc-next-button" style={finishStyle} onClick={formValidFinal ? this.finish : null}>FINISH</div>
                </div>
            </div>
        );
    }
}